const SDK = {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  STRIPE_KEY: process.env.REACT_APP_STRIPE_KEY,
  FB_PIXEL_ID: process.env.REACT_APP_FB_PIXEL_ID,
  TIK_TOK_PIXEL_ID: process.env.REACT_APP_TIK_TOK_PIXEL_ID,
  FB_CURRNECY: process.env.REACT_APP_FB_CURRNECY,
  FB_PRICE: Number(process.env.REACT_APP_FB_PRICE),
  APPLE_PAY_PRICE: Number(process.env.REACT_APP_APPLE_PAY_PRICE),
  APPLE_PAY_CURRENCY: process.env.REACT_APP_APPLE_PAY_CURRENCY,
};

export default SDK;
